import React, { useMemo } from 'react';
import cx from 'classnames';

function horizontalTransform(slant) {
  if (slant) {
    return {
      transformOrigin: 'right',
      transform: `translate(-100%, -50%) rotate(-${slant}deg)`,
      textAlign: 'right',
    };
  } else {
    return { transform: 'translateX(-50%)', textAlign: 'center' };
  }
}

function verticalTransform(slant) {
  if (slant) {
    return slant === 90
      ? { transform: 'translateY(-50%)', textAlign: 'right' }
      : {
          textAlign: 'right',
          transformOrigin: 'right',
          transform: `translateY(-50%) rotate(${90 - slant}deg)`,
        };
  } else {
    return {
      transformOrigin: 'top center',
      transform: 'translate(50%, 0%) rotate(90deg)',
    };
  }
}

function tickStyles({ slant, axis }) {
  if (axis === 'x') {
    return horizontalTransform(slant);
  } else if (axis === 'y') {
    return verticalTransform(slant);
  } else {
    return {};
  }
}

const WHITESPACE_REGEX = /\s/;
function useIsSingleWord(value) {
  return useMemo(() => !WHITESPACE_REGEX.test(value), [value]);
}

function Label({ value, coords, slant, axis, size, style }) {
  const singleWord = useIsSingleWord(value);

  return (
    <span
      className={cx('axis__label', {
        'axis__label--single-line': slant || singleWord,
      })}
      style={{
        width: size,
        ...coords,
        ...tickStyles({ slant, axis }),
        ...style,
      }}
    >
      {value}
    </span>
  );
}

export default Label;
